import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, Globe2Icon, LockKeyholeIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Button } from './Button';
const checkoutUrl = 'https://ballet-teacher-ready.impultienda.ar/checkout';
const includes = ['6 complete volumes of ready-to-teach ballet classes', 'Classes organized by technical objective and level', 'An entire year of content—nothing to build from scratch', 'Every class fully structured with step-by-step sequences', 'Teacher cues, corrections, and transitions included', '100 Ready-to-Teach Ballet Combinations', 'Ballet Corrections and Teacher Cueing Library', '50 Creative Pre-Ballet Activities', 'Ballet Recital and Rehearsal Planner', 'Ballet Progress Tracking and Assessment System', '7-day money-back guarantee'];
function trackCheckout() {
  const fbq = (window as Window & {
    fbq?: (...args: unknown[]) => void;
  }).fbq;
  fbq?.('track', 'InitiateCheckout', {
    content_name: 'Ballet Teacher Ready Complete Teaching Library',
    value: 27,
    currency: 'USD'
  });
}
export function PricingSection() {
  return <section id="pricing" className="bg-ballet-canvas px-4 py-20 sm:py-28" data-id="element-189">
      <div className="mx-auto max-w-3xl" data-id="element-190">
        <div className="text-center" data-id="element-191">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-ballet-rose" data-id="element-192">
            Your complete offer today
          </p>
          <h2 className="mt-3 font-display text-5xl font-semibold text-ballet-ink" data-id="element-193">
            Everything your next class needs
          </h2>
          <p className="mt-4 text-base leading-7 text-ballet-muted" data-id="element-194">
            Complete Teaching Library + 5 Strategic Bonuses—ready for your next
            class.
          </p>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative mt-12 rounded-3xl border border-ballet-gold/70 bg-white p-2 shadow-soft" data-id="element-195">
          <div className="absolute -top-4 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 rounded-full border border-ballet-gold/60 bg-ballet-goldSoft px-4 py-1.5 text-xs font-bold uppercase tracking-[0.1em] text-ballet-ink" data-id="element-196">
            <SparklesIcon size={14} data-id="element-197" /> Complete pack
          </div>
          <div className="rounded-[1.25rem] bg-ballet-canvas p-6 text-center sm:p-10" data-id="element-198">
            <h3 className="font-display text-4xl font-semibold text-ballet-ink" data-id="element-199">
              Ballet Teacher Ready™
            </h3>
            <p className="mt-2 text-ballet-muted" data-id="element-200">
              The complete professional library to teach ballet with confidence.
            </p>
            <ul className="mx-auto mt-7 max-w-xl space-y-2.5 rounded-2xl border border-ballet-line bg-white p-5 text-left" data-id="element-201">
              {includes.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-ballet-muted" data-id="element-202">
                  <CheckIcon size={17} className="mt-0.5 shrink-0 text-ballet-gold" data-id="element-203" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-8" data-id="element-204">
              <span className="block text-lg text-ballet-muted line-through" data-id="element-205">
                USD $105.00
              </span>
              <div className="mt-1 flex items-baseline justify-center gap-2" data-id="element-206">
                <span className="text-xl font-semibold text-ballet-ink" data-id="element-207">
                  TODAY:
                </span>
                <span className="font-display text-5xl font-semibold text-ballet-rose" data-id="element-208">
                  USD $27.00
                </span>
              </div>
            </div>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="mt-7 w-full sm:w-auto" data-id="element-209">
              GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ballet-muted" data-id="element-210">
              <span className="flex items-center gap-1.5" data-id="element-211">
                <LockKeyholeIcon size={14} className="text-ballet-gold" data-id="element-212" />
                Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-213">
                <ZapIcon size={14} className="text-ballet-gold" data-id="element-214" />
                Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-215">
                <ShieldCheckIcon size={14} className="text-ballet-gold" data-id="element-216" />
                7-day guarantee
              </span>
            </div>
            <p className="mx-auto mt-5 flex max-w-lg items-start gap-2 rounded-xl border border-ballet-line bg-white p-3 text-left text-xs leading-5 text-ballet-muted" data-id="element-217">
              <Globe2Icon size={15} className="mt-0.5 shrink-0 text-ballet-gold" data-id="element-218" />
              Pay in your local currency. The amount adapts automatically based
              on the country you are purchasing from.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}